import { createContext, useContext } from 'react';

import { RootStore } from './RootStore';

export let stores: RootStore | null = null;

export const StoresContext = createContext<RootStore | null>(null);

export function createStores() {
  stores = stores || new RootStore();
  return stores;
}

// For use as hook in components
export function useStores() {
  const ctx = useContext(StoresContext);

  if (!ctx) {
    throw new Error('useStores must be used within a StoresProvider.');
  }

  return ctx;
}
